import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { OC_API_URL } from '@/shared/constants/linksApi'

// Данные для Basic Auth
const API_USER = process.env.API_USER || 'testuser'
const API_PASS = process.env.API_PASS || 'testbtpeel748'
const basicAuth = 'Basic ' + Buffer.from(`${API_USER}:${API_PASS}`).toString('base64')

export const ocApi = createApi({
    reducerPath: 'ocApi',
    baseQuery: fetchBaseQuery({
        baseUrl: OC_API_URL,
        mode: 'cors',
        credentials: 'include',
        prepareHeaders: (headers) => {
            headers.set('Authorization', basicAuth)
            headers.set('Content-Type', 'application/json')
            return headers
        },
    }),
    tagTypes: ['cart'],
    endpoints: (builder) => ({
        basic: builder.query({
            query: () => 'basic',
        }),
        getCartItems: builder.query({
            query: () => 'd_quickcheckout/cart/getCartItems',
        }),
    }),
})
